/** @jsxImportSource theme-ui */
import React from 'react';
import { Label } from 'semantic-ui-react';
import { SxProp } from 'theme-ui';

import { sxtheme, valignHackBottom } from 'utils/cssHelpers';

import { Typography } from 'components/_common/Typography';

import { IconButton } from '../IconButton';

export type ChipOptions = {
  id: string | number;
  label: string;
  hasPrefixEllipse?: boolean;
  prefixEllipseColor?: string;
  disabled?: boolean;
};

type BdChipProps = SxProp & {
  /** Id of the item, required for removing */
  id: string | number;
  /** The text that appears */
  label: string;
  /** Hides the label **Used for filter chip group** */
  hidden?: boolean;
  /** If there is a prefix ellipse, use this color */
  prefixEllipseColor?: string;
  /** If true there will be a prefix ellipse */
  hasPrefixEllipse?: boolean;
  disabled?: boolean;
  onDelete?: (id: string | number) => void;
};

const BdChip: React.FC<BdChipProps> = ({
  id,
  label,
  hidden = false,
  prefixEllipseColor = '#000',
  hasPrefixEllipse = false,
  disabled = false,
  onDelete = null,
  ...props
}) => {
  return (
    <Label
      data-testid="selection-item-label"
      className="selection item"
      sx={{
        '&.ui.label': {
          display: hidden ? 'none' : 'inline-block',
          bg: sxtheme(t => t.colors.deepSea30),
          opacity: disabled ? 0.5 : 1,
          pointerEvents: disabled ? 'none' : 'all',
          m: '0 10px 10px 0',
          padding: '8px 10px',
          ...props.sx,
        },
      }}
      {...props}
    >
      {hasPrefixEllipse && (
        <svg
          sx={{ mr: '10px' }}
          width="8"
          height="8"
          viewBox="0 0 8 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            data-testid="label-prefix-ellipse"
            cx="4"
            cy="4"
            r="4"
            fill={prefixEllipseColor}
          />
        </svg>
      )}
      <Typography variant="body2" color="stone90" inline>
        {label}
      </Typography>
      <IconButton
        data-testid="delete-selection-icon"
        data-html2canvas-ignore="true"
        ariaLabel={`Remove ${label}`}
        size="small"
        icon="icon-close"
        color="stone90"
        bold
        disabled={disabled}
        onClick={() => onDelete(id)}
        sx={{ ...valignHackBottom('2px'), ml: '8px' }}
      />
    </Label>
  );
};

export default BdChip;
